<template>
  <component
    :is="errorComponent.name"
    v-bind="errorComponent.props"
    data-testid="error-state-component"
    @onClickButton="onClick"
  />
</template>

<script>
import { ErrorDefault, ErrorPidLimit } from '@/components/base';

export default {
  name: 'HandleErrorType',
  components: {
    ErrorDefault,
    ErrorPidLimit,
  },
  props: {
    errorType: {
      type: String,
      default: 'ErrorDefault',
    },
    onClick: {
      type: Function,
      default: null,
    },
  },
  computed: {
    errorComponent() {
      const errorsComponentTypes = {
        ErrorDefault: {
          name: 'ErrorDefault',
          props: {
            show: true,
          },
        },
        ErrorPidLimit: {
          name: 'ErrorPidLimit',
          props: {},
        },
      };

      return this.errorType in errorsComponentTypes
        ? errorsComponentTypes[this.errorType]
        : errorsComponentTypes.ErrorDefault;
    },
  },
};
</script>
